import React from 'react';
import PropTypes from 'prop-types';

import Button from '../button/Button';
import images from '../../assets/images';
import styles from '../../assets/css/modal/modal.module.css';

const AlertCustom = ({
    showModal,
    closeModal,
    typeAlert,
    title,
    subtitle,
    children
}) => {
    return (
        <div
            className={`${styles.popUp} ${styles.pMedium} ${
                showModal && styles.show
            }`}>
            <div
                className={`${styles.popUpWrapper} ${styles.modalXs} ${
                    showModal && styles.show
                }`}>
                <div className={styles.modal}>
                    <div className={styles.modalBody}>
                        <div className={styles.alert}>
                            <div className={styles.alertIcon}>
                                {typeAlert === 'success' && (
                                    <img src={images.iconSuccess} alt="icon" />
                                )}
                            </div>
                            <h1 className={styles.alertTitle}>{title}</h1>
                            <p className={styles.alertSubTitle}>{subtitle}</p>

                            <footer className={styles.alertFooter}>
                                {typeAlert === 'success' && <>{children}</>}

                                {typeAlert === 'phone' && <>{children}</>}

                                {typeAlert === 'info' && <>{children}</>}

                                {typeAlert === 'confirm' && (
                                    <>
                                        {children}
                                        <Button
                                            onClick={closeModal}
                                            classs="btnOutlineMain"
                                            text="Cancel"
                                        />
                                    </>
                                )}
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
AlertCustom.propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func,
    typeAlert: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    children: PropTypes.any
};

export default AlertCustom;
